// Apple Search Ads attribution as the tracker sees it: the iOS app reads its
// AdServices attribution and, when Apple attributes the install, opens the
// tracker link with ?asa=1 plus the campaign / ad group / keyword ids.

export interface AsaFields {
  isAsa: number | null | undefined;
  campaignId: string | null | undefined;
  adGroupId: string | null | undefined;
  keywordId: string | null | undefined;
}

/** Table cell: badge + campaign / keyword ids when present, or a dash. */
export function AsaCell({ isAsa, campaignId, keywordId }: AsaFields) {
  if (!isAsa) return <span className="text-xs text-content-subtle">—</span>;
  return (
    <div className="flex flex-col gap-0.5">
      <span className="px-1.5 py-0.5 rounded text-[11px] font-medium w-fit bg-fuchsia-500/15 text-fuchsia-500">ASA</span>
      {campaignId && <span className="text-[11px] text-content-subtle font-mono">camp {campaignId}</span>}
      {keywordId && <span className="text-[11px] text-content-subtle font-mono">kw {keywordId}</span>}
    </div>
  );
}

/** Details-modal block with every id. */
export function AsaDetails({ isAsa, campaignId, adGroupId, keywordId }: AsaFields) {
  const ids: [string, string | null | undefined][] = [
    ['Campaign ID', campaignId], ['Ad group ID', adGroupId], ['Keyword ID', keywordId],
  ];
  return (
    <div className="border-t pt-3 mt-3">
      <div className="text-[11px] uppercase tracking-wide text-content-subtle mb-2">Apple Search Ads</div>
      {!isAsa ? (
        <div className="text-xs text-content-subtle">Not from Apple Search Ads</div>
      ) : (
        <div className="grid grid-cols-3 gap-3">
          {ids.map(([label, v]) => (
            <div key={label}>
              <div className="text-[11px] uppercase tracking-wide text-content-subtle">{label}</div>
              <div className="text-sm text-content break-all font-mono">{v || '—'}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export const ASA_FILTER_OPTIONS = [
  { value: '', label: 'All traffic' },
  { value: '1', label: 'Apple Search Ads only' },
  { value: '0', label: 'Not Apple Search Ads' },
];
